import { defineMessages } from 'react-intl';

export const scope = 'app.component.base.avatar';

export default defineMessages({
  avatar: {
    id: `${scope}.avatar`,
    defaultMessage: 'avatar',
  },
});
